import React from 'react';
import './RegisterDoktorRightSide.css';
import googleicon from '../../../assets/images/google-icon.png';

const RegisterDoktorRightSide = ({ setShowFirstStep }) => {
    return (
        <section className="register-doktor-right-section">
            <h1>Kayıt Ol</h1>
            <button className="google-button">
                <img src={googleicon} alt="google-icon" />
                Google ile Hesap Aç
            </button>
            <div className="divider">
                <span>Veya</span>
            </div>
            <form className="form" onSubmit={(e) => {
                e.preventDefault();
                setShowFirstStep(true);
            }}>
                <div className="form-row">
                    <div className="form-group">
                        <label>İsim</label>
                        <input type="text" className='isim-soyisim' />
                    </div>
                    <div className="form-group">
                        <label>Soyisim</label>
                        <input type="text" className='isim-soyisim' />
                    </div>
                </div>

                <div className="form-group">
                    <label>Mail</label>
                    <input type="email" />
                </div>

                <div className="form-group">
                    <label>Şifre</label>
                    <input type="password" placeholder="Şifre (6+ Karakter)" />
                </div>

                <div className="checkbox-group">
                    <label><input type="checkbox" /> Doktor</label>
                    <label><input type="checkbox" /> Terapist</label>
                </div>

                <div className="checkbox-terms">
                    <label>
                        <input type="checkbox" /> Bir hesap oluşturmak, Hizmet Şartlarımızı, Gizlilik Politikamızı ve varsayılan Bildirim Ayarlarımızı kabul ettiğiniz anlamına gelir.
                    </label>
                </div>

                <button type="submit" className="create-account-button">Hesap Oluştur</button>
            </form>
        </section>
    );
};


export default RegisterDoktorRightSide;
